/**
 * Created by - Ashlekh on 04-02-2025
 * Reason - To add Global presence
 */
import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { globalPresence } from "../../Api/services";
import globalPresenceStyle from "./GlobalPresence.module.css";
import parse from "html-react-parser";
import { baseURL } from "../../Api/config";
import Globe from "react-globe.gl";
import { Modal } from "antd";
import { Tabs } from "antd";
import CountryCard from "./CountryCard";
import { GlobalContext } from "../../context/Context";
import { Link } from "react-router-dom";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import { AiOutlineExclamation } from "react-icons/ai";
import { IoInformationCircleOutline } from "react-icons/io5";

const GlobalPresence = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);

  const [globalPresencePageDetails, setGlobalPresencePageDetails] =
    useState("");
  const [globalPresenceCountries, setGlobalPresenceCountries] = useState([]);
  const [globeData, setGlobeData] = useState([]);

  const globeElement = useRef();
  const [globeComponentWidth, setGlobeComponentWidth] = useState(
    window.innerWidth
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({});

  const [countryTabs, setCountryTabs] = useState([]);

  const [toolTipForGlobeForMobile, setToolTipForGlobeForMobile] =
    useState(false);

  const [showContent, setShowContent] = useState(false);

  const MarkerSvg = `<svg viewBox="-4 0 36 36">
      <path fill="currentColor" d="M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z"></path>
      <circle fill="black" cx="14" cy="14" r="7"></circle>
    </svg>`;
  // Added by - Ashlekh on 04-02-2025
  // Reason - To get global presence details
  const fetchGlobalPresenceData = async () => {
    try {
      const response = await globalPresence();
      setGlobalPresencePageDetails(
        response.global_presence_page_details.page_content
      );
      setGlobalPresenceCountries(response.global_presence_countries);
    } catch (error) {
      console.error("Error fetching global presence details:", error);
    } finally {
      setShowContent(true);
    }
  };
  // End of code - Ashlekh on 04-02-2025
  // Reason - To get global presence details
  
  // Added by - Ashlekh on 04-02-2025
  // Reason - This useEffect will execute when page loads and will set navigation path
  useEffect(() => {
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Global Presence", path: "/global-presence" },
    ]);
    window.scrollTo(0, 0);
    fetchGlobalPresenceData();
  }, []);
  // End of code - Ashlekh on 04-02-2025
  // Reason - This useEffect will execute when page loads and will set navigation path
  useEffect(() => {
    setGlobeData(
      globalPresenceCountries.map((country) => ({
        size: 25,
        color: "red",
        lat: country.latitude,
        lng: country.longitude,
        id: country.id,
        continent: country.continent,
        country_name: country.country_name,
        calling_code: country.calling_code,
        calling_number: country.calling_number,
        email: country.email,
        address: country.address,
        google_map_link: country.google_map_link,
      }))
    );
    setCountryTabs([
      {
        key: "1",
        label: "Headquarters",
        children: (
          <div className={globalPresenceStyle.countryCardContainer}>
            {globalPresenceCountries.map((country, index) => {
              if (country.is_headquarter)
                return <CountryCard country={country} />;
            })}
          </div>
        ),
      },
      {
        key: "2",
        label: "Other Locations",
        children: (
          <div className={globalPresenceStyle.pageDetails}>
            {parse(globalPresencePageDetails)}
          </div>
        ),
      },
    ]);
  }, [globalPresenceCountries]);
  useLayoutEffect(() => {
    function updateSize() {
      var style = getComputedStyle(document.body);
      if (window.innerWidth > 720) {
        setGlobeComponentWidth(parseInt(window.innerWidth) - 17);
      } else {
        setGlobeComponentWidth(parseInt(window.innerWidth));
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  useEffect(() => {
    const checkScreenWidth = () => {
      if (window.innerWidth > 720) {
        setToolTipForGlobeForMobile(false);
      }
    };
    checkScreenWidth();
    window.addEventListener("resize", checkScreenWidth);
    return () => window.removeEventListener("resize", checkScreenWidth);
  }, []);
  useEffect(() => {
    const handleClick = (event) => {
      let targetElement = event.target;
      const svgPath = document.querySelectorAll("#tooltipIconId path");
      console.log("setToolTipForGlobeForMobile:", svgPath);

      if (
        targetElement.id == "tooltipDivId" ||
        targetElement.id == "tooltipButtonId" ||
        targetElement.id == "tooltipIconId" ||
        Array.from(svgPath).some((path) => path === targetElement)
      ) {
        return;
      } else {
        setToolTipForGlobeForMobile(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  const handletooltipClick = () => {
    setToolTipForGlobeForMobile((prevState) => !prevState);
  };
  const showCountryDetails = (country) => {
    setSelectedCountry(country);
    setIsModalOpen(true);
  };
  return (
    <>
      {showContent ? (
        <div className={globalPresenceStyle.mainContainer}>
          <div className={globalPresenceStyle.worldGlobeContainer}>
            <button
              onClick={handletooltipClick}
              id="tooltipButtonId"
              className={globalPresenceStyle.tooltipButton}
              style={{ cursor: "pointer" }}
            >
              <div
                className={globalPresenceStyle.buttonContainer}
                id="tooltipDivId"
              >
                <IoInformationCircleOutline
                  className={globalPresenceStyle.tooltipIcon}
                  id="tooltipIconId"
                />
              </div>
            </button>
            {toolTipForGlobeForMobile && (
              <div className={globalPresenceStyle.toolTipForGlobeForMobile}>
                <strong>How to use the globe:</strong>
                <ul className={globalPresenceStyle.toolTips}>
                  <li>Tap on markers to view country details.</li>
                  <li>Swipe to rotate the globe.</li>
                  <li>Pinch to zoom in or out.</li>
                </ul>
              </div>
            )}
            <div className={globalPresenceStyle.toolTipForGlobe}>
              <strong>How to use the globe:</strong>
              <ul className={globalPresenceStyle.toolTips}>
                <li>Click on markers to view country details.</li>
                <li>Drag to rotate the globe.</li>
                <li>Scroll to zoom in or out.</li>
              </ul>
            </div>
            <div className={globalPresenceStyle.rotationIconContainer}>
              <img
                src="/rotate-removebg-preview.png"
                className={globalPresenceStyle.rotationIcon}
              />
            </div>
            <Globe
              ref={globeElement}
              globeImageUrl="//unpkg.com/three-globe/example/img/earth-day.jpg"
              backgroundImageUrl={"bgimage1.jpg"}
              htmlElementsData={globeData}
              width={globeComponentWidth}
              height={400}
              backgroundColor="rgba(0,0,0,0)"
              onGlobeReady={(e) => {
                const MAP_CENTER = {
                  lat: 20.5937,
                  lng: 78.9629,
                  altitude: 2,
                };
                globeElement?.current?.pointOfView(MAP_CENTER, 500);
              }}
              htmlElement={(d) => {
                const el = document.createElement("div");
                el.innerHTML = MarkerSvg;
                el.style.color = d.color;
                el.style.width = `${d.size}px`;
                el.style["pointer-events"] = "auto";
                el.style.cursor = "pointer";
                el.onclick = () => {
                  showCountryDetails(d);
                };
                return el;
              }}
            />
          </div>
          <Modal
            open={isModalOpen}
            onCancel={(e) => {
              setIsModalOpen(false);
            }}
            onClose={(e) => {
              setIsModalOpen(false);
            }}
            footer={null}
            centered={true}
          >
            <CountryCard country={selectedCountry} />
          </Modal>
          <div className={globalPresenceStyle.pageContentContainer}>
            <NavigationPath navigationPathArray={navigationPath} />
            {globalPresencePageDetails?.trim()?.length < 1 &&
            globalPresenceCountries?.length < 1 ? (
              <div className={globalPresenceStyle.noDetails}>
                <p className={globalPresenceStyle.noDetailText}>
                  No details available
                </p>
              </div>
            ) : (
              <div className={globalPresenceStyle.pageTitle}>
                Global Presence
              </div>
            )}
            {globalPresenceCountries.length > 0 && (
              <div className={globalPresenceStyle.countriesContainer}>
                <Tabs
                  defaultActiveKey="1"
                  items={countryTabs}
                  tabBarStyle={{ fontSize: "140px" }}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={globalPresenceStyle.loaderContent}>
          <img style={{ height: "30vh" }} src="adyant_loader.gif" />
        </div>
      )}
    </>
  );
};

export default GlobalPresence;
